import { render, staticRenderFns } from "./ElAffix.vue?vue&type=template&id=2afa62b8&scoped=true&"
import script from "./ElAffix.vue?vue&type=script&lang=ts&"
export * from "./ElAffix.vue?vue&type=script&lang=ts&"
import style0 from "./ElAffix.vue?vue&type=style&index=0&id=2afa62b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa62b8",
  null
  
)

export default component.exports